import {Component, OnInit} from '@angular/core';
import {AlertService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import {MatDialog} from "@angular/material/dialog";
import {ComponentTitleService} from "../services/componentTitle.service";
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";

import { locale as polish } from './i18n/pl';
import {SupplierService} from "../services/supplier.service";
import {ManufacturerService} from "../services/manufacturer.service";

@Component({
    templateUrl: './manufacturerForm.component.html',
    styleUrls: ['./manufacturerForm.component.scss']
})

export class ManufacturerFormComponent implements OnInit {

    form: FormGroup;
    loading = false;
    submitted = false;
    id: string;
    isAddMode: boolean;
    categories: any[];
    units: any[];

    constructor(
        public _matDialog: MatDialog,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private manufacturerService: ManufacturerService
    ) {
        this.translationLoader.loadTranslations(polish);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Manufacturers');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.isAddMode = !this.id;

        if (this.isAddMode) {
            this.componentTitleService.addPart('New');
        } else {
            this.componentTitleService.addPart('Edit');
        }

        this.form = this.formBuilder.group({
            name: ['', Validators.required],
        });

        if (!this.isAddMode) {
            this.manufacturerService.getById(this.id)
                .pipe(first())
                .subscribe(x => {
                    this.f.name.setValue(x.name);
                });
        }
    }

    // convenience getter for easy access to form fields
    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        if (this.isAddMode) {
            this.createManufacturer();
        } else {
            this.updateManufacturer();
        }
    }

    private createManufacturer() {
        this.manufacturerService.create(this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Manufacturer added successfully', { keepAfterRouteChange: true });
                    this.router.navigate(['.', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private updateManufacturer() {
        this.manufacturerService.update(this.id, this.form.value)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Update successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }
}
